import React, {useEffect, useMemo, useState} from 'react';
import ReactDOM from 'react-dom/client';
import {ConfigProvider} from 'antd';
import {MotionConfig} from 'framer-motion';
import '@fontsource-variable/geist/wght.css';
import '@fontsource-variable/geist-mono/wght.css';
import './theme/tokens.css';
import App from './App';
import {antdTheme} from './theme/antdTheme';
import reportWebVitals from './reportWebVitals';

function useMediaQuery(query: string) {
    const get = () => typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
    const [matches, setMatches] = useState(get);
    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return;
        const list = window.matchMedia(query);
        const onChange = () => setMatches(list.matches);
        list.addEventListener('change', onChange);
        return () => list.removeEventListener('change', onChange);
    }, [query]);
    return matches;
}

function Root() {
    const isDark = useMediaQuery('(prefers-color-scheme: dark)');
    const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
    const theme = useMemo(() => antdTheme(isDark, reduceMotion), [isDark, reduceMotion]);

    useEffect(() => {
        ConfigProvider.config({
            holderRender: (children) => <ConfigProvider theme={theme}>{children}</ConfigProvider>,
        });
    }, [theme]);

    return (
        <ConfigProvider theme={theme}>
            <MotionConfig reducedMotion="user">
                <App/>
            </MotionConfig>
        </ConfigProvider>
    );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Root/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
